








import { Vue, Component } from "@/shared/vuepack";
import IdentityChallenge from "./IdentityChallenge.vue";
import DemographicConfirmation from "./DemographicConfirmation.vue";
import Review from "@/employee/components/onboarding/Review.vue";
import { BankCustodian } from "@/admin/types";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    DemographicConfirmation,
    IdentityChallenge,
    Review
  }
})
export default class VerifyIdentity extends Vue {
  contactInfoStore = useContactInfoStore();
  custodianSettingsStore = useCustodianSettingsStore();

  get isHsaBankCustodian () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }

  onStepComplete (e) {
    this.$emit("complete", e); // pass it up the chain
  }
}
